"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calcLCP = exports.calcFID = exports.calcCLS = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _utils = require("../../utils");
var _webVitals = require("../../../utils/web-vitals");
var ts = +new Date();
// just 测试
0 && (0, _webVitals.onLCP)(function (data) {
  (0, _utils.LogError)('Test-onLCP', data, +new Date() - ts);
});
var TIME_OUT = 10 * 1e3; //

var wrapResolve = function wrapResolve(type, res) {
  var timer = setTimeout(function () {
    var _res;
    res((_res = {}, (0, _defineProperty2.default)(_res, type, '0'), (0, _defineProperty2.default)(_res, "type", type), (0, _defineProperty2.default)(_res, "msg", '执行超时'), _res));
    // LogInfo('web-vitals 获取超时', type);
  }, TIME_OUT);
  switch (type) {
    case 'cls':
      (0, _webVitals.onCLS)(function (data) {
        var _data$value;
        clearTimeout(timer);
        // LogInfo(type, data)
        res({
          data: data,
          value: +(data === null || data === void 0 ? void 0 : (_data$value = data.value) === null || _data$value === void 0 ? void 0 : _data$value.toFixed(2)),
          type: type,
          msg: ''
        });
      });
      break;
    case 'lcp':
      (0, _webVitals.onLCP)(function (data) {
        var _data$value2;
        clearTimeout(timer);
        // LogInfo(type, data)
        res({
          data: data,
          value: +((_data$value2 = data.value) === null || _data$value2 === void 0 ? void 0 : _data$value2.toFixed(2)),
          type: type,
          msg: ''
        });
      });
      break;
    case 'fid':
      (0, _webVitals.onFID)(function (data) {
        var _data$value3;
        clearTimeout(timer);
        // LogInfo(type, data)
        res({
          data: data,
          value: +((_data$value3 = data.value) === null || _data$value3 === void 0 ? void 0 : _data$value3.toFixed(2)),
          type: type,
          msg: ''
        });
      });
      break;
    default:
      (0, _utils.LogError)('web-vital 模块异常，未发现该函数名');
      return;
  }
};
var calcCLS = function calcCLS() {
  return new Promise(function (res) {
    return wrapResolve('cls', res);
  });
};
exports.calcCLS = calcCLS;
var calcFID = function calcFID() {
  return new Promise(function (res) {
    return wrapResolve('fid', res);
  });
};
exports.calcFID = calcFID;
var calcLCP = function calcLCP() {
  return new Promise(function (res) {
    return wrapResolve('lcp', res);
  });
};
exports.calcLCP = calcLCP;